export const POS_NOT_TOP50 = 666;